import { priceRegex } from "utils/pricingsConsts";

export const handleValidation = (offer) => {
    const {id, title, description, reward_ids, unit_price, image_files, category, event_id, free, content_text, min_amount} = offer;
    validateTitle(title);
    if (category !== "ticket") validateDescription(description);
    validateEligibilityCriteria(reward_ids);
    validatePrice(unit_price, free);
    if (category !== "ticket") validateImages(image_files);
    if (category === "ticket") validateEvent(event_id);
    if (!id && content_text) validateContentText(content_text);
    if (min_amount) validateMinAmount(min_amount);
    if (category === "merch") validateVariants(offer.options, offer.variants);
};

// SELL06 — every SKU row must set a value for every declared axis, and no two
// rows may stock the same tuple.
const validateVariants = (options, variants) => {
    if (!variants || variants.length === 0) return;

    // Mirror createFormData's cleanOptions: a half-declared axis is not sent, so
    // it must not be demanded of every variant either.
    const axisNames = (options || [])
        .filter((axis) => axis.name.trim() && (axis.values || []).some((value) => value.trim()))
        .map((axis) => axis.name.trim());
    if (axisNames.length === 0) {
        throw "Please declare at least one option (e.g. Size) before adding variants";
    }

    const seen = new Set();
    variants.forEach((variant) => {
        const tuple = axisNames.map((name) => variant.options?.[name]);
        if (tuple.some((value) => !value)) {
            throw "Every variant must pick a value for every option";
        }
        const key = tuple.join("||");
        if (seen.has(key)) {
            throw `Duplicate variant: ${tuple.join(" / ")}`;
        }
        seen.add(key);
    });

    validateOptionValues(options, variants);
};

// SELL18 — values are append-only once a saved variant keys on them: dropping one
// would leave that SKU's tuple pointing at a value the menu no longer declares.
// Checked here rather than per keystroke so the field stays freely editable.
const validateOptionValues = (options, variants) => {
    const saved = variants.filter((variant) => variant.id);

    (options || []).forEach((axis) => {
        const name = axis.name.trim();
        const declared = (axis.values || []).map((value) => value.trim()).filter(Boolean);

        if (declared.length !== new Set(declared).size) {
            throw `Each value of "${name}" must be unique`;
        }

        const withdrawn = saved
            .map((variant) => variant.options?.[name])
            .filter((value) => value && !declared.includes(value));

        if (withdrawn.length > 0) {
            const list = [...new Set(withdrawn)].join(", ");
            throw `Cannot remove "${name}" values that variants already stock: ${list}`;
        }
    });
};

const validateTitle = (title) => {
    if (title.trim() === ""){
        throw "Please provide a title";
    }
};

const validateDescription = (description) => {
    if (description.trim() === ""){
        throw "Please provide a description";
    }
};

const validateEligibilityCriteria = (reward_ids) => {
    if (!reward_ids || reward_ids.length === 0) {
        throw "Please specify in Eligibility Criteria, who you would like to be able to redeem this perk";
    }
};

const validatePrice = (price, free) => {
    if (!price && free) {
        return
    } else if (!price && !free) {
        throw "Please provide a price or indicate that you would like this to be free";
    } else if (!priceRegex.test(price)) {
        throw "Price must be in this format: 123456.12";
    }
};

const validateImages = (image_files) => {
    if (!image_files || image_files.length === 0) {
        throw "Please upload at least 1 image";
    }
};

const validateEvent = (event_id) => {
    if (!event_id) {
        throw "Please associate an event to this ticket";
    }
};

const validateContentText = (content_text) => {
    if (content_text.length > 1000) {
        throw "Content text must be less than 1000 characters";
    }
};

const validateMinAmount = (min_amount) => {
    if (min_amount < 1) {
        throw "Minimum amount must be higher than 0";
    }
};
